/* less/lib/less/visitors/index */ function _(require, module, exports) {
    var visitors = {
        Visitor: require(253) /* ./visitor */,
        ImportVisitor: require(248) /* ./import-visitor */,
        MarkVisibleSelectorsVisitor: require(251) /* ./set-tree-visibility-visitor */,
        ExtendVisitor: require(246) /* ./extend-visitor */,
        JoinSelectorVisitor: require(250) /* ./join-selector-visitor */,
        ToCSSVisitor: require(252) /* ./to-css-visitor */
    };
    module.exports = visitors;
}
